// Change this value should the banner ever have to be re-surfaced to the user
export var LIMITED_REP_BANNER_LOCAL_STORAGE_KEY = 'limited-rep-banner';
export var PREVIEW_REP_BANNER_LOCAL_STORAGE_KEY = 'preview-rep-banner';
export var CANCELED_REP_BANNER_LOCAL_STORAGE_KEY = 'canceled-rep-banner';
export var CANCELED_NEW_REP_BANNER_LOCAL_STORAGE_KEY = 'canceled-new-rep-banner';
export var PAUSED_REP_BANNER_LOCAL_STORAGE_KEY = 'paused-rep-banner';
export var UPCOMING_PAUSE_REP_BANNER_LOCAL_STORAGE_KEY = 'upcoming-pause-rep-banner';
export var BANNER_HIDDEN_VALUE = 'hidden';
export var REP_BANNER_ID = 'rep-banner';
export var UPDATE_BANNER_ID = 'update-banner';